import {
  adobeActiveApps,
  adobePageNames,
  adobePageNamesSuffix,
  adobeUrls,
} from "../config/adobe.config";
import { getQueryParams } from "../utils";

const useAdobeDataLayer = () => {
  const pageURL = window.location.href;
  const siteSection = "registration";
  const pageNamePrefix = "insurance:vitality:johnhancockinsurance:";

  const events = {
    registrationStart: "registrationStart",
    registrationComplete: "registrationComplete",
    pageLoad: "pageLoad",
    registrationError: "registrationError",
  };

  //   For Reference
  //   window.location.href: 'http://localhost:3000/auth/login?appId=362772';
  //   window.location.origin: 'http://localhost:3000';
  //   window.location.pathname: '/auth/login';

  const pushHandler = (eventObject) => {
    const { appId } = getQueryParams();
    const isActiveByAppAndEnv =
      adobeActiveApps[appId]?.[process.env.REACT_APP_ENV];
    const isDatalayerOn = process.env.REACT_APP_DATA_LAYER === "enabled"; // global switch

    // isDatalayerOn: Switch to toggle datalayer between regions. Will be applicable for all appId id's.
    // isActiveByAppAndEnv: feature will be turned on and off according to appId and environment
    if (!isDatalayerOn || !isActiveByAppAndEnv) return;

    const analyticLayer = window.adobeDataLayer;
    if (!analyticLayer) window.adobeDataLayer = [];

    console.log("datalayer event:", eventObject.event);

    window.adobeDataLayer.push(eventObject);
  };

  const addAdobeScript = () => {
    const { appId } = getQueryParams();
    const isActiveByApp =
      adobeActiveApps[appId]?.[process.env.REACT_APP_ENV];
    const isDatalayerOn = process.env.REACT_APP_DATA_LAYER === "enabled"; // global switch

    console.log("my check", {
      adobeActiveApps,
      appId,
      env: process.env.REACT_APP_ENV,
      globalDatalayerSwitch: isDatalayerOn,
      isActiveByApp
    });

    if (isActiveByApp && isDatalayerOn) {
      console.log("Loading Datalayer Script...");
      const dlScript = document.createElement("script");
      dlScript.src = adobeUrls[appId];
      dlScript.async = true;
      window.document.head.appendChild(dlScript);
    }
  };

  // This event needs to fire when the user lands on the page mention below where the registration starts (after the user and pageLoad event)
  const registrationStart = () => {
    const { appId } = getQueryParams();
    const pageNamePrefix = adobePageNames[appId] || "";
    const pageNameSuffix = adobePageNamesSuffix.step1;
    pushHandler({
      event: events.registrationStart,
      page: {
        pageName: `${pageNamePrefix} ${pageNameSuffix}`,
        siteSection,
        pageURL,
      },
    });
  };

  // This event needs to fire when the user successfully registers (This can be via API call or a pageview of the confirmation page)
  const registrationComplete = (userID = "") => {
    const { appId } = getQueryParams();
    const pageNamePrefix = adobePageNames[appId] || "";
    const pageNameSuffix = adobePageNamesSuffix.registrationComplete;

    pushHandler({
      event: events.registrationComplete,
      page: {
        pageName: `${pageNamePrefix} ${pageNameSuffix}`,
        siteSection,
        pageURL,
      },
      user: {
        userID,
      },
    });
  };

  // "This pageview events needs to fire when the user lands on the pages mentioned
  const pageLoad = (pageName = "") => {
    const { appId } = getQueryParams();
    const pageNamePrefix = adobePageNames[appId] || "";
    const pageNameSuffix = adobePageNamesSuffix[pageName];

    pushHandler({
      event: events.pageLoad,
      page: {
        pageName: `${pageNamePrefix} ${pageNameSuffix}`,
        siteSection,
        pageURL,
      },
    });
  };

  //   Error Types are as below
  //   incorrect-user-password-combination
  //   third-attempt-failature-setup
  //   thrird-attempt-failature-verify
  //   user-session-expired
  const registrationUnsuccessfull = ({
    errorType,
    errorCode,
    errorDescription = "Something went wrong!",
  }) => {
    const { appId } = getQueryParams();
    const pageNamePrefix = adobePageNames[appId] || "";
    const pageNameSuffix = adobePageNamesSuffix.step3;

    pushHandler({
      event: events.registrationError,
      error: {
        errorType,
        errorCode,
        errorCategory: "registration-error",
        errorDescription,
      },
      page: {
        pageName: `${pageNamePrefix} ${pageNameSuffix}`,
        siteSection,
        pageURL,
      },
    });
  };

  return {
    registrationStart,
    registrationComplete,
    pageLoad,
    registrationUnsuccessfull,
    addAdobeScript,
  };
};

export default useAdobeDataLayer;
